import { ApplicationConfig } from '@angular/core';
import { MenuService } from 'app';
import { createAppConfig } from 'credo';
import { Logo } from 'shared';
import { routes } from './app.routes';
import { logo } from './assets/icons/logo';
import { environment } from './environments/environment';
import { MnloMenuService } from './services/menu.service';

// "mnlo" (board.mnlo.app) is a credo-based re-skin that shares the fac3less
// backend tenant (userDomainId 0) but is config domain id 6 in the backend.
// It reuses the fac3less translations and layers a "mnlo" override scope on top
// so it can override just the branded keys (e.g. app.name).
// Special rules: self-registration is disabled and cross-domain login is off
// (enforced server-side); users are created only via CSV import.
export const appConfig: ApplicationConfig = createAppConfig({
  routes,
  // Override the shared credo menu with the mnlo variant that exposes only the
  // five mnlo menu items (provided last so it wins over createAppConfig's
  // default MenuService binding).
  providers: [
    { provide: MenuService, useClass: MnloMenuService },
  ],
  translationScope: 'fac3less,mnlo',
  environment,
  // Light theme with the MNLO brand blue (matches the logo + admin screenshot).
  theme: {
    mode: 'light',
    colors: {
      primary:   "#1B82C7",
      secondary: "#9da5b1",
      success:   "#2eb85c",
      info:      "#3399ff",
      warning:   "#f9b115",
      danger:    "#e55353",
      light:     "#ebedef",
      dark:      "#212631"
    }
  },
  logo: {
      type: 'icon',
      value: logo,
      name: 'mnlo-logo',
      cssClass: 'logo'
  } as Logo
});
